import axios from "axios";
import { Constants } from "../utils/Constants";

export function gerarTokenSso() {
  return axios.post(`${Constants.baseUrl}/pump/gerar-token-sso`);
}
